<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="展示位置" prop="type">
                <a-select v-model="queryParam.type" placeholder="请选择展示位置">
                  <a-select-option value="1">
                    首页
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="链接类型" prop="linkType">
                <a-select v-model="queryParam.linkType" placeholder="请选择链接类型">
                  <a-select-option value="1">
                    不跳转
                  </a-select-option>
                  <a-select-option value="2">
                    外链
                  </a-select-option>
<!--                  <a-select-option value="3">-->
<!--                    普通商品-->
<!--                  </a-select-option>-->
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否启用" prop="useFlag">
                  <a-select v-model="queryParam.useFlag" placeholder="请选择是否启用">
                    <a-select-option value="0">
                      禁用
                    </a-select-option>
                    <a-select-option value="1">
                      启用
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="排序" prop="sort">-->
<!--                  <a-input v-model="queryParam.sort" placeholder="请输入排序" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['banner:banner:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['banner:banner:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['banner:banner:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['banner:banner:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
<!--        <table-setting-->
<!--          :style="{float: 'right'}"-->
<!--          :table-size.sync="tableSize"-->
<!--          v-model="columns"-->
<!--          :refresh-loading="loading"-->
<!--          @refresh="getList" />-->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <a-switch slot="useFlag" slot-scope="text, record" @click="updateGoodsState(record)" v-model="record.useFlag == 1">
          <a-icon type="check" slot="checkedChildren"/>
          <a-icon type="close" slot="unCheckedChildren"/>
        </a-switch>
        <span slot="link" slot-scope="text, record" >
          <a :href="record.link" v-if="record.linkType == 2">{{record.link}}</a>
        </span>
        <img style="width: 152px;height: 75px;" v-image-preview :src="record.imgUrl" slot="imgUrl" slot-scope="text, record">

        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['banner:banner:edit']" />-->
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['banner:banner:edit']">
<!--            <a-icon type="edit" />-->
           编辑
          </a>
          <a-divider type="vertical" v-hasPermi="['banner:banner:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['banner:banner:remove']">
<!--            <a-icon type="delete" />-->
            删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBanner,listBanner, delBanner,saveFlag } from '@/api/banner/banner'
import CreateForm from './modules/CreateModalForm'
import { tableMixin } from '@/store/table-mixin'
import {  } from "@/api/gift/gift";

export default {
  name: 'Banner',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        cateName: null,
        type: null,
        title: null,
        content: null,
        imgUrl: null,
        linkType: null,
        link: null,
        useFlag: null,
        sort: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          align: 'center',
          width: 60,
          customRender:function (text, record, index) {
            return (index + 1);
          }
        },
        // {
        //   title: '标题',
        //   dataIndex: 'title',
        //   ellipsis: true,
        //   align: 'center'
        // },

        {
          title: '展示位置',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text == 1) {
              return '首页'
            }
          }
        },
        // {
        //   title: '分类名称',
        //   dataIndex: 'cateName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '内容',
        //   dataIndex: 'content',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '图片地址',
          dataIndex: 'imgUrl',
          width: 155,
          align: 'center',
          scopedSlots: { customRender: 'imgUrl' }
        },
        {
          title: '链接类型',
          dataIndex: 'linkType',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text == 1) {
              return '不跳转'
            } else if(text == 2){
              return '外链'
            }
          }
        },
        {
          title: '跳转链接',
          dataIndex: 'link',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'link' }
        },
        {
          title: '是否启用',
          dataIndex: 'useFlag',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'useFlag' }
        },
        {
          title: '排序',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /**
     * 启用/禁用
     */
    updateGoodsState(record) {
      console.log(record)
      let editRecordData = {
        id:record.id,
        useFlag:record.useFlag == 1 ? 0 : 1
      }
      saveFlag(editRecordData).then(response => {
        // this.$message.success(
        //   '修改成功',
        //   3
        // )
        // this.open = false
        if(response.code == 20001) {
          record.useFlag = record.useFlag == 1? 0 : 1
        } else {

        }
        // this.$emit('ok')
      }).finally(() => {
        // this.submitLoading = false
      })
    },
    /** 查询轮播图列表 */
    getList () {
      this.loading = true
     pageBanner(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        cateName: undefined,
        type: undefined,
        title: undefined,
        content: undefined,
        imgUrl: undefined,
        linkType: undefined,
        link: undefined,
        useFlag: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delBanner(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('banner/banner/export', {
            ...that.queryParam
          }, `轮播图_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
